import { render, staticRenderFns } from "./zhaohuimima.vue?vue&type=template&id=61455c3d&"
import script from "./zhaohuimima.vue?vue&type=script&lang=js&"
export * from "./zhaohuimima.vue?vue&type=script&lang=js&"
import style0 from "./zhaohuimima.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports